import React, { useCallback, useContext, useEffect, useState } from 'react'
import * as Icon from '@desenvolvimento-intuix/ui-icons'

import { PaginateContext } from '../../contexts/paginate'

import { Container } from './styles'

export const Paginate: React.FC = () => {
  const {
    index,
    endIndex,
    totalItems,
    isFirstPage,
    isLastPage,
    nextPage,
    previousPage
  } = useContext(PaginateContext)

  const [formattedIndex, setFormattedIndex] = useState(0)

  const [formattedEndIndex, setFormattedEndIndex] = useState(0)

  const formatIndex = useCallback(() => {
    setFormattedIndex(index + 1)
  }, [index])

  useEffect(() => {
    formatIndex()
  }, [formatIndex])

  const formatEndIndex = useCallback(() => {
    setFormattedEndIndex(totalItems < endIndex ? totalItems : endIndex)
  }, [totalItems, endIndex])

  useEffect(() => {
    formatEndIndex()
  }, [formatEndIndex])

  return (
    <Container className='table-paginate'>
      <span>{formattedIndex}</span> - <span>{formattedEndIndex}</span> de{' '}
      <span>{totalItems}</span>
      <button type='button' disabled={isFirstPage()} onClick={previousPage}>
        <Icon.ChevronLeft />
      </button>
      <button type='button' disabled={isLastPage()} onClick={nextPage}>
        <Icon.ChevronRight />
      </button>
    </Container>
  )
}
